import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ArrayFilterPipe } from './array-filter.pipe';

@NgModule({
    imports: [
        CommonModule,
        FormsModule
    ],
    declarations: [ArrayFilterPipe],
    exports: [ArrayFilterPipe]
})
export class ArrayFilterModule { }
